

















import axios from 'axios';
import { get } from 'lodash';
import CoEditor from '@/components/Molecules/co-editor/CoEditor.vue';
import EventBus from '@/eventBus';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoCard from '@/components/Molecules/co-card/CoCard.vue';

export default {
    name: 'CoNoteCreate',
    components: {
        CoEditor,
        CoIcon,
        CoCard,
    },
    props: {
        user: {
            type: Object,
            default: () => ({}),
        },
        placeholder: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            note: {
                Text: '',
            },
            editorContent: {},
            loading: false,
            isEditorEmpty: true,
            me: this.$store?.state?.me || {},
        };
    },
    methods: {
        publishNote() {
            this.loading = true;
            this.note.UserID = this.user.ID;
            this.note.AuthorID = this.me.ID;
            this.note.AuthorName = this.me?.Profile?.Name;
            this.createNote();
        },
        cancelNote() {
            this.$refs.noteEditor.clear(true, true);
        },
        createNote() {
            if (get(this.editorContent, 'Text', '').length === 0) {
                this.loading = false;
                return;
            }
            const newNote = {
                ...this.note,
                Text: this.editorContent.Html,
            };
            axios
                .post('/admin/notes', newNote, {
                    withCredentials: true,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((response) => {
                    EventBus.$emit('INFO', {
                        Message: 'Note published',
                        Details: '',
                    });

                    this.loading = false;

                    this.$refs.noteEditor.clear(true, true);
                    this.$emit('created');
                })
                .catch((error) => {
                    this.loading = false;
                    EventBus.$emit('ERROR', {
                        Message: error.response?.data?.message || 'Could not create note. Please try again later.',
                        Details: error.response?.data?.details || null,
                    });
                });
        },
    },
};
